import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=54844ec4&scoped=true&"
import script from "./Quotations.vue?vue&type=script&lang=ts&"
export * from "./Quotations.vue?vue&type=script&lang=ts&"
import style0 from "./Quotations.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Quotations.vue?vue&type=style&index=1&id=54844ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54844ec4",
  null
  
)

export default component.exports